/** Only same-site paths are accepted as a post-login destination. */
export function safeReturnPath(value) {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) return null;
  return value;
}

export function loginUrl(next) {
  const path = safeReturnPath(next);
  return path ? `/?login=1&next=${encodeURIComponent(path)}` : "/?login=1";
}
